import React from 'react';
import { Modal, Box, Typography, Button, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination, Navigation } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';
import 'swiper/css/navigation';

const companies = [
  {
    name: 'ICONIA',
    description: 'Somos el complemento perfecto para tu estilo de vida. Una combinación de practicidad, diseño, tecnología y aprovechamiento del espacio.',
    logo: '/assets/images/iconia.png',
    website: 'https://iconnia.com/',
  },
  {
    name: 'Portafolio Inmobiliario',
    description: 'Somos líderes en el desarrollo de proyectos industriales, corporativos, comerciales, residenciales y de uso mixto de la región centroamericana.',
    logo: '/assets/images/portafolio.svg',
    website: 'https://www.portafolio.cr/es',
  },
  {
    name: 'Sky Garden',
    description: 'Torre de apartamentos en condominio, ubicada en Nunciatura, cuyo objetivo es facilitar y mejorar la calidad y el estilo de vida de sus usuarios.',
    logo: '/assets/images/sky2.webp',
    website: 'https://citizeninmobiliaria.com/sky-garden-nunciatura-torre-de-apartamentos/',
  },
  {
    name: 'URBN ESCALANTE-CORE',
    description: 'VivÍ en el corazón de barrio Escalante. Disfrutá del arte y diseño URBN. Te ayudamos a que tu experiencia en URBN Escalante sea la mejor posible.',
    logo: '/assets/images/urbn.png',
    website: 'https://www.core.cr/urbn-escalante',
  },
  {
    name: 'Secrt-CORE',
    description: 'Creamos comunidades inclusivas y diversas, donde el arte, la cultura y la gastronomía prosperan. Defendiendo los derechos humanos y la igualdad.',
    logo: '/assets/images/secrt.jpeg',
    website: 'https://www.core.cr/secrt-1',
  },
  {
    name: 'CIVITAR',
    description: 'Somos una empresa costarricense especializada en el desarrollo de proyectos residenciales innovadores que mejoran la calidad de vida de las personas.',
    logo: '/assets/images/civitar.png',
    website: 'https://civitar.com/',
  },
];

interface RealEstateModalProps {
  open: boolean;
  onClose: () => void;
  sx?: object;
}

const RealEstateModal: React.FC<RealEstateModalProps> = ({ open, onClose }) => {
  return (
    <Modal open={open} onClose={onClose} aria-labelledby="modal-title" aria-describedby="modal-description">
      <Box
        sx={{
          position: 'absolute',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: { xs: '80%',lg: '70%', xl: '60%' }, 
          bgcolor: 'background.paper',
          borderRadius: 4,
          boxShadow: 24,
          p: 4,
          overflow: 'hidden', // Evitar desbordamiento
        }}
      >
        {/* Header del modal con título y botón de cerrar */}
        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
          <Typography id="modal-title" variant="h6" component="h2">
            Empresas Inmobiliarias
          </Typography>
          <IconButton onClick={onClose}>
            <CloseIcon />
          </IconButton>
        </Box>
        <Typography id="modal-description" sx={{ mb: 2 }}>
          Conoce las principales inmobiliarias y sus ofertas en propiedades exclusivas.
        </Typography>

        {/* Carrusel con Swiper */}
        <Swiper
          modules={[Autoplay, Pagination, Navigation]}
          spaceBetween={40} 
          slidesPerView={1} 
          autoplay={{ delay: 3000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          navigation
          breakpoints={{
            240: {
              slidesPerView: 1,
            },
            640: {
              slidesPerView: 1,
            },
            768: {
              slidesPerView: 2,
            },
            1024: {
              slidesPerView: 3,
            },
          }}
          style={{ paddingBottom: '40px', width: '100%' }} 
        >
          {companies.map((company, index) => (
            <SwiperSlide key={index}>
              <Box
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'center',
                  border: '1px solid #e0e0e0',
                  borderRadius: 2,
                  p: 2,
                  textAlign: 'center',
                  transition: 'transform 0.3s ease',
                  height: { xs: 'auto', sm: '300px' }, 
                  maxWidth: '300px',
                  width: '100%',
                  margin: '0 auto',
                  '&:hover': {
                    transform: 'scale(1.02)',
                    boxShadow: 4,
                  },
                }}
              >
                <Box
                  component="img"
                  src={company.logo}
                  alt={company.name}
                  sx={{
                    width: '80%',
                    height: '100px',
                    objectFit: 'contain',
                    margin: '0 auto',
                    p:2,
                    backgroundColor: 'lightblue',
                    borderRadius: 1,
                    mb: 1,
                  }}
                />
                <Typography variant="h6" component="h3" gutterBottom>
                  {company.name}
                </Typography>
                <Typography variant="body2" color="textSecondary" sx={{ mb: 2, fontSize:{md:'12px', lg:'14px'}}}>
                  {company.description}
                </Typography>
                <Button
                  variant="contained"
                  color="success"
                  href={company.website}
                  target="_blank"
                  sx={{
                    textTransform: 'none',
                    borderRadius: '20px',
                    padding: '4px 12px',
                    '&:hover': { backgroundColor: 'success.dark' },
                  }}
                >
                  Visitar Sitio Web
                </Button>
              </Box>
            </SwiperSlide>
          ))}
        </Swiper>
      </Box>
    </Modal>
  );
};

export default RealEstateModal;